import { openDB } from 'idb';

export const logout = async () => {
  try {
    // Clear localStorage
    localStorage.removeItem('ark_authToken');
    localStorage.removeItem('ark_current_bank_details');
    localStorage.removeItem('ark_admin_widget_lastRefresh');
    localStorage.removeItem('ark_dashboard_widget');
    localStorage.removeItem('ark_lastLogin');
    localStorage.removeItem('ark_currentLogin');

    // Close any open database connections before deleting
    const db = await openDB('ark_database', 3); // your current version
    db.close();

    // Delete the database
    const deleteRequest = indexedDB.deleteDatabase('ark_database');

    deleteRequest.onsuccess = () => {
      console.log('IndexedDB deleted successfully');
    };

    deleteRequest.onerror = (event) => {
      console.error('Error deleting IndexedDB', event);
    };

    deleteRequest.onblocked = () => {
      console.warn(
        'Delete blocked: Make sure no other tabs or connections are using the database.'
      );
    };
  } catch (error) {
    console.error('Logout failed:', error);
  }
};
